
/**
 * by zhou 2016-7-22
 */

'use strict';

angular.module('advancedSearchModule', []).controller('advancedSearchCtrl', ['$scope', '$filter', '$modalInstance', 'trsHttpService', '$validation',
    function($scope, $filter, $modalInstance, trsHttpService, $validation) {
        initStatus();

        /**
         * [initStatus description]
         *
         * @return  {[type]}   [return description]
         */
        function initStatus() {
            $scope.status = {
                search: {
                    type: '2',
                    strsortmethod: '-operator_time',
                    operator: '',
                    medianame: '',
                    displayname: '',
                    time: '1m',
                    ip: '',
                    operatedesc: ''
                }
            };
            // 默认显示 起始时间和结束时间
            var date = new Date();
            $scope.fromDate = date.setMonth(date.getMonth() - 1);
            $scope.untilDate = date.setMonth(date.getMonth() + 1);
            $scope.minformDate = date.setMonth(date.getMonth() - 1) - 60 * 60 * 24 * 1000;
        }
        // $scope.$watch("fromDate",function(newValue, oldValue) {
        //     $scope.minformDate = newValue - 60*60*24*1000;
        // });
        /**
         * [cancel description] 取消
         * @return {[type]} [description]
         */
        $scope.cancel = function() {
            $modalInstance.dismiss();
        };

        /**
         * [selectTime description]选择时间段之后触发的函数
         * @return {[type]} [description]
         */
        $scope.selectTime = function() {
            $scope.status.search.time = $scope.status.untildate ? $scope.status.fromdate + ';' + $scope.status.untildate : '1m';
        };

        /**
         * [getSuggestions description]所属产品的模糊查询
         *
         * @param  {[type]}  viewValue   [viewValue description]
         *
         * @return  {[type]}   [return description]
         */
        $scope.getSuggestions = function(viewValue) {
            if (viewValue !== '') {
                var params = {
                    serviceid: 'mlf_website',
                    methodname: 'queryWebsites',
                    searchValue: viewValue
                };
                if ($scope.isRequest) {
                    $scope.isRequest = false;
                    return [];
                } else {
                    return trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then(function(data) {
                        return data.DATA;
                    });
                }
            }
        };
        $scope.$watch('status.search.medianame', function(newValue, oldValue) {
            if (angular.isObject(newValue)) {
                $scope.isRequest = true;
                $scope.status.search.medianame = newValue.SITENAME;
            }
        });

        /**
         * [send description] 确定  filter 返回查询起始时间和结束时间
         * @return {[type]} [description]
         */
        $scope.send = function() {
            $modalInstance.close($scope.status.search);
        };
    }
]);
